
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg","stroke":"#292D32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 17.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.333 15.027v-2.054c0-1.213.992-2.216 2.217-2.216 2.112 0 2.975-1.494 1.913-3.325A2.216 2.216 0 017.28 4.41l2.018-1.155c.922-.548 2.112-.222 2.66.7l.129.222c1.05 1.831 2.776 1.831 3.838 0l.128-.222c.549-.922 1.739-1.248 2.66-.7l2.019 1.155a2.216 2.216 0 01.816 3.022c-1.061 1.831-.198 3.325 1.914 3.325 1.213 0 2.216.991 2.216 2.216v2.053a2.223 2.223 0 01-2.216 2.217c-2.112 0-2.975 1.494-1.914 3.325a2.213 2.213 0 01-.816 3.022l-2.019 1.155c-.921.548-2.111.221-2.66-.7l-.128-.222c-1.05-1.832-2.777-1.832-3.838 0l-.129.222c-.548.921-1.738 1.248-2.66.7L7.28 23.59a2.216 2.216 0 01-.817-3.022c1.062-1.832.199-3.325-1.913-3.325a2.223 2.223 0 01-2.217-2.216z","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    